// extracted by mini-css-extract-plugin
export var infoRow = "_ps-2";
export var labelContainer = "_ps-0";
export var rightInfo = "_ps-1";